export enum VehicleUsage
{
    Unknown = 0,
    Low = 1,
    Medium = 2,
    High = 3
}

export namespace VehicleUsage
{
    /**
     * Converts the usage to kilometers
     * @param type 
     * @returns 
     */
    export function toKilometers( type: VehicleUsage ): number | undefined
    {
        switch( type )
        {
            case VehicleUsage.Low: return 10000;
            case VehicleUsage.Medium: return 15000;
            case VehicleUsage.High: return 20000;
            default: return undefined;
        }
    }
}